export interface IGridDefinition {
  mediaUrl: string[] | ((item: any) => string);
  title: string[] | ((item: any) => string);
  subtitle?: string[] | ((item: any) => string);
  date?: string[];
  portalData?: {
    name: string; // name of component for DynamicComponent pipe
  }
}
